export const _sessionFr = {
    needLogIn: 'Vous devez être connecté pour utiliser ce module.',
    logIn: 'Me connecter',
    signUp: 'M\'inscrire',
    logSign: 'Se connecter / S\'inscrire',
    forgotPwd: 'J\'ai oublié mon mot de passe',
    rememberSession: 'Se souvenir de mon nom d\'utilisateur',
    noAccount: 'Vous n\'avez pas de compte',
    accountExist: 'Vous avez un compte',
    userName: 'Nom de compte',
    email: 'Email',
    password: 'Mot de passe',
    confirm: 'Confirmer votre',
    code: 'Si vous possédez un code de parrainage',
    forgotIndications: 'Veuillez saisir votre nom d\'utilisateur.' +
        '\nNous vous enverrons un e- mail afin de redéfinir votre mot de passe.',
};

export const _sessionEn = {
    needLogIn: 'You must be logged in to use this module.',
    logIn: 'Sign in',
    signUp: 'Sign Up',
    logSign: 'Log in / Sign in',
    forgotPwd: 'I forgot my password',
    rememberSession: 'Remember my username',
    noAccount: 'Don\'t have an account',
    accountExist: 'Have an account',
    userName: 'Account name',
    email: 'Email',
    password: 'Password',
    confirm: 'Confirm your',
    code: 'If you have a sponsorship code',
    forgotIndications: 'Please enter your username, we will send you an email to reset your password.',
};

export const _sessionDe = {
    needLogIn: 'Sie müssen angemeldet sein, um dieses Modul zu verwenden.',
    logIn: 'Einloggen',
    signUp: 'Anmelden',
    logSign: 'Anmelden / Registrieren',
    forgotPwd: 'Ich habe mein Passwort vergessen',
    rememberSession: 'Erinnere dich an meinen Benutzernamen',
    noAccount: 'Sie haben noch kein Konto',
    accountExist: 'Sie haben ein Konto',
    userName: 'Benutzername',
    email: 'Email',
    password: 'Passwort',
    confirm: 'Bestätigen Sie Ihr',
    code: 'Wenn Sie einen Sponsoring-Code haben',
    forgotIndications: 'Bitte geben Sie Ihren Benutzernamen ein, wir senden Ihnen eine E-Mail, um Ihr Passwort zurückzusetzen.',
};
